'use strict';

var __assign =
  (void 0 && (void 0).__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

    return __assign.apply(this, arguments);
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

var react_1 = __importDefault(require('react'));

var Icon_1 = __importDefault(require('../Icon'));

var Rename = function Rename(props) {
  return react_1.default.createElement(
    Icon_1.default,
    __assign({}, props),
    react_1.default.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19.5 2.99805H15V4.49805L16.5001 4.49805V19.5043H15V21.0043H19.5V19.5043H18.0001V4.49805L19.5 4.49805V2.99805ZM5.71642 17.0002H4L8.20896 7.00018H9.79104L14 17.0002H12.2836L11.1493 14.2288H6.85075L5.71642 17.0002ZM8.67164 9.70018L7.38806 12.8573H10.6119L9.32836 9.70018C9.31528 9.66264 9.2933 9.60195 9.26538 9.52487C9.19769 9.338 9.0951 9.05481 9 8.77161C8.9049 9.05481 8.80231 9.33801 8.73462 9.52488C8.7067 9.60195 8.68472 9.66264 8.67164 9.70018Z',
    })
  );
};

Rename.displayName = 'Rename';
exports.default = Rename;
